import createElement from '../logical-components/createElement';
// Global helpers
import svgs from './svgs';
import renderText from '../logical-components/renderText';
import internalEvents from '../logical-components/internalEvents';
import imageServiceUrlBuilder from '../core/utils/imageServiceUrl';
var template = function (arg) {
    return "<img src='".concat(imageServiceUrlBuilder("".concat(arg.url)), "' alt='").concat(arg.file_name, "' />");
};
var GalleryCard = function (config, section, arg, galleryWrapper, showMore, total, handleClick) {
    var _a;
    var events = internalEvents(config);
    var card = createElement('div', [
        { type: 'class', value: '_mnslq-rememberMe-imagewrapper' },
    ]);
    card.innerHTML = "<div class='_mslq-g-c-w'></div>";
    var content = card.querySelector('._mslq-g-c-w');
    if (showMore) {
        var moreButtonWrap = createElement('div', [
            { type: 'class', value: '_msnlq-gal-more' },
        ]);
        moreButtonWrap.innerHTML = "<div class='_msnlq-gal-more-text'> +".concat(total - 3, " </div>");
        card.appendChild(moreButtonWrap);
    }
    if ((_a = section === null || section === void 0 ? void 0 : section.views) === null || _a === void 0 ? void 0 : _a.galleryCard) {
        var ele = section.views.galleryCard({
            config: config,
            section: section,
            svgs: svgs,
            data: arg,
            renderText: renderText,
            events: events,
            wrapper: galleryWrapper,
        });
        if (typeof ele === 'string') {
            content.innerHTML = ele;
        }
        else {
            content.appendChild(ele);
        }
    }
    else {
        content.innerHTML = template(arg);
    }
    card.addEventListener('click', function () {
        handleClick();
    });
    return card;
};
var rememberMeGallery = function (config, section, gallery) {
    var _a;
    var galleryWrapper = createElement('div');
    if (((_a = config === null || config === void 0 ? void 0 : config.options) === null || _a === void 0 ? void 0 : _a.hideGallery) || !gallery || !gallery.length) {
        return galleryWrapper;
    }
    var numberOfImages = 3;
    var showMore = gallery.length > numberOfImages;
    var showOverlay = false;
    var imageIndex = 0;
    galleryWrapper.innerHTML = "\n        <h3> ".concat(renderText('rememberMe.gallery'), " </h3> \n        \n        <div class='_msnlq-glr-c-wrap'> </div>\n        <div class='_msnlq-glr-overlay-wrap _msnlq-glr-hide'>\n            <div class='_msnlq-glr-img'>\n                <img src='").concat(gallery[0].url, "' alt='Mensenlinq' />\n            </div>\n            <div class='_msnlq-glr-close'> ").concat(svgs.close, " </div>\n            <div class='_msnlq-glr-leftarrow'> ").concat(svgs.arrow, "</div>\n            <div class='_msnlq-glr-rightarrow'> ").concat(svgs.arrow, " </div>\n        </div>\n    ");
    var toggle = function () {
        var overlay = galleryWrapper.querySelector('._msnlq-glr-overlay-wrap');
        if (showOverlay) {
            overlay.classList.remove('_msnlq-glr-hide');
        }
        else {
            overlay.classList.add('_msnlq-glr-hide');
        }
    };
    var changeImage = function (index) {
        galleryWrapper
            .querySelector('._msnlq-glr-overlay-wrap')
            .querySelector('img').src = gallery[index].url;
    };
    var openOverlay = function (index) {
        imageIndex = index;
        changeImage(imageIndex);
        showOverlay = !showOverlay;
        toggle();
    };
    var closeOverlay = function () {
        showOverlay = !showOverlay;
        toggle();
    };
    var nextImage = function () {
        imageIndex = imageIndex + 1;
        if (imageIndex > gallery.length - 1) {
            imageIndex = 0;
        }
        changeImage(imageIndex);
    };
    var prevImage = function () {
        imageIndex = imageIndex - 1;
        if (imageIndex === -1) {
            imageIndex = gallery.length - 1;
        }
        changeImage(imageIndex);
    };
    gallery.forEach(function (image, index) {
        if (index >= numberOfImages) {
            return;
        }
        galleryWrapper.querySelector('._msnlq-glr-c-wrap').appendChild(GalleryCard(config, section, image, galleryWrapper, index + 1 === numberOfImages && showMore, gallery.length, function () {
            openOverlay(index);
        }));
    });
    galleryWrapper
        .querySelector('._msnlq-glr-close')
        .addEventListener('click', function () {
        closeOverlay();
    });
    galleryWrapper
        .querySelector('._msnlq-glr-leftarrow')
        .addEventListener('click', function () {
        prevImage();
    });
    galleryWrapper
        .querySelector('._msnlq-glr-rightarrow')
        .addEventListener('click', function () {
        nextImage();
    });
    return galleryWrapper;
};
export default rememberMeGallery;
